// Simple product slider with keyboard navigation
export function initProductSlider(container) {
  const slides = container.querySelectorAll('.product-slider__slide');
  const thumbnails = container.querySelectorAll('.product-slider__thumbnail');
  const prevBtn = container.querySelector('[data-slider-prev]');
  const nextBtn = container.querySelector('[data-slider-next]');

  let currentIndex = 0;

  function goToSlide(index) {
    // Remove active class from all
    slides.forEach(slide => slide.classList.remove('is-active'));
    thumbnails.forEach(thumb => thumb.classList.remove('is-active'));

    // Add active class to current
    slides[index].classList.add('is-active');
    if (thumbnails[index]) {
      thumbnails[index].classList.add('is-active');
    }

    currentIndex = index;
  }

  function nextSlide() {
    const next = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
    goToSlide(next);
  }

  function prevSlide() {
    const prev = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
    goToSlide(prev);
  }

  // Arrow button navigation
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  // Thumbnail navigation
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => goToSlide(index));
  });

  // Keyboard navigation (Arrow keys)
  container.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextSlide();
    }
  });

  // Make container focusable for keyboard nav
  container.setAttribute('tabindex', '0');

  // Drag / swipe navigation. Pointer events cover mouse + touch + pen in one
  // listener set, so we don't need separate touch/mouse handlers.
  const main = container.querySelector('.product-slider__main') || container;
  const dragThreshold = 50; // px before a drag counts as a swipe
  let isDragging = false;
  let dragStartX = 0;
  let dragMoved = 0;

  main.addEventListener('pointerdown', (e) => {
    // Ignore right-click / middle-click drags
    if (e.button !== undefined && e.button !== 0) return;
    isDragging = true;
    dragStartX = e.clientX;
    dragMoved = 0;
    // Set a class so CSS can suppress image dragging / show a grab cursor
    main.classList.add('is-dragging');
    // Capture the pointer so we keep getting events even if the cursor
    // leaves the element mid-drag
    main.setPointerCapture?.(e.pointerId);
  });

  main.addEventListener('pointermove', (e) => {
    if (!isDragging) return;
    dragMoved = e.clientX - dragStartX;
  });

  function endDrag(e) {
    if (!isDragging) return;
    isDragging = false;
    main.classList.remove('is-dragging');
    main.releasePointerCapture?.(e.pointerId);

    if (Math.abs(dragMoved) >= dragThreshold) {
      if (dragMoved < 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
    dragMoved = 0;
  }

  main.addEventListener('pointerup', endDrag);
  main.addEventListener('pointercancel', endDrag);

  // Stop the browser's native image-drag behaviour from hijacking the swipe
  main.querySelectorAll('img').forEach((img) => {
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });
}

// Auto-initialize all product sliders
export function autoInitProductSliders() {
  const sliders = document.querySelectorAll('[data-product-slider]');
  sliders.forEach(slider => initProductSlider(slider));
}

// Initialize on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInitProductSliders);
} else {
  autoInitProductSliders();
}
